import {
  Autocomplete,
  InputAdornment,
  TextField,
} from "@mui/material";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useTranslation } from "react-i18next";

const AutoComplete: FC<Props> = ({
  onChange,
  onChoose,
  options,
  label = "Teczki",
  variant = "filled",
  labelPosition = "top",
  disableBorder = false,
  size = "medium",
  autoFocus = false,
  disableClearable = false,
}) => {
  const { t } = useTranslation();
  const getInputProps = () => {
    return {
      startAdornment:
        labelPosition === "start" ? (
          <InputAdornment style={{}} position="start">
            {labelPosition === "start" && (
              <div className={`${styles.startAdornment}`}>{label}</div>
            )}
          </InputAdornment>
        ) : undefined,

      disableUnderline: disableBorder ? true : false,
      // readOnly: disabled,
    };
  };

  return (
    <div className={styles.wrapper}>
      <Autocomplete
        noOptionsText={t("emptyStates.noElements")}
        sx={{ width: "100%" }}
        disableClearable={disableClearable}
        clearText={t("common.clear")}
        closeText={t("common.collapse")}
        openText={t("common.showMore")}
        // open={open}
        openOnFocus={true}
        options={options}
        getOptionLabel={(o) => o.label}
        onChange={(a, b) => {
          if (b) {
            onChoose(b.id);
          }
        }}
        disableListWrap={true}
        size={size}
        componentsProps={{
          popper: {
            sx: {
              zIndex: 100000,
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            className={styles.b}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            variant={variant}
            // onChange={(e) => setValue(e.target.value)}
            {...params}
            label={labelPosition === "top" ? label : null}
            style={{
              width: "100%",
              // height: height,
            }}
            size={size}
            InputProps={{
              ...params.InputProps,
              ...getInputProps(),
              disableUnderline: disableBorder,
            }}
            autoFocus={autoFocus}
            /* styles the label component */
          />
        )}
        renderOption={(props, option: any) => (
          <li
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              display: "block",
            }}
            {...props}
          >
            {option.label}
          </li>
        )}
      />
    </div>
  );
};

export default AutoComplete;
